import { SharingData } from '../../schema/SharingData';
import { cannotShareExternally } from '../../selectors/sharingIssueDetectors/cannotShareExternally';
import { cannotShareWithLargeDL } from '../../selectors/sharingIssueDetectors/cannotShareWithLargeDL';
import { didGetSharingInfoFail } from '../../selectors/sharingIssueDetectors/didGetSharingInfoFail';
import { isCSLWithExternalRecipients } from '../../selectors/sharingIssueDetectors/isCSLWithExternalRecipients';
import { isExpired } from '../../selectors/sharingIssueDetectors/isExpired';
import { isExpiring } from '../../selectors/sharingIssueDetectors/isExpiring';
import { isPermissionNotSet } from '../../selectors/sharingIssueDetectors/isPermissionNotSet';
import { isUnshareable } from '../../selectors/sharingIssueDetectors/isUnshareable';
import { SharingTipId } from '../../types/sharingTipId';
import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import { assertNever } from 'owa-assert';

export function getIssueDetector(
    sharingTipId: SharingTipId
): (sharingData: SharingData, recipientInfo: SharingTipRecipientInfo[]) => boolean {
    switch (sharingTipId) {
        case SharingTipId.noPermissionToShare:
            return isUnshareable;
        case SharingTipId.getSharingInfoFailed:
            return didGetSharingInfoFail;
        case SharingTipId.linkHasExpired:
            return isExpired;
        case SharingTipId.linkWillExpire:
            return isExpiring;
        case SharingTipId.externalRecipientCSL:
            return isCSLWithExternalRecipients;
        case SharingTipId.noPermissionToShareExternally:
            return cannotShareExternally;
        case SharingTipId.noPermissionSet:
            return isPermissionNotSet;
        case SharingTipId.sharingWithLargeDL:
            return cannotShareWithLargeDL;
        default:
            return assertNever(sharingTipId);
    }
}
